/* SimpliCarto display fixes for labels that come from Gelato's palette widget and Shopify variant names (#81).
   Display only: the text a shopper reads changes, never the variant or the value that is added to the cart.
   - Size buttons: "21x29.7 cm / 8x12″" reads "8x12″" (a U.S. store sizes in inches).
   - Palette label: "<Map> Color Palate", "<Map> Color Palette" or "<Map> Colors" reads "Palette" on every map, matching "Size" and
     "Frame" (the Gelato layer names vary by map and carry a typo; the real fix is in Gelato). */
(function () {
  var SIZE = /^\s*[\d.]+x[\d.]+\s*cm\s*\/\s*(\d+x\d+\s*["″]?)\s*$/i;
  var PALATE = /^\s*\S.*?\s+(Colou?r\s+Pal[ae]tt?e|Colou?rs)\s*$/i;
  function fixText(node) {
    var t = node.nodeValue;
    if (!t || t.trim().length < 4) return;
    var m = t.match(SIZE);
    var next = m ? t.replace(SIZE, function (_, inches) { return inches.replace(/"$/, "″"); }) : t;
    if (PALATE.test(next)) next = "Palette";
    if (next !== t) node.nodeValue = next;
  }
  function walk(root) {
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var p = n.parentNode && n.parentNode.nodeName;
      if (p === "SCRIPT" || p === "STYLE") continue;
      fixText(n);
    }
  }
  function scope() { return document.querySelector(".product__info-wrapper") || document.querySelector("main") || document.body; }
  function run() {
    var root = scope();
    walk(root);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === "characterData") fixText(m.target);
        m.addedNodes && m.addedNodes.forEach(function (n) { n.nodeType === 3 ? fixText(n) : walk(n); });
      });
    }).observe(root, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run); else run();
})();
